module.exports = __webpack_public_path__ + "img/circle-white.eeb7db67.svg";